import DiceParser from '../../services/diceParser';
import { matchRecursive, resolveTreeExpressions, expandTreeExpressions, evaluateMathExpressions } from '../../services/matchRecursive';

export const Message = (email, user, color, command, content, groupId=null) => {
    return {
        userId: email,
        initial: user.substr(0,1).toUpperCase(),
        name: user,
        color,
        groupId,
        message: {command, content}
    }
};

const criticalManager = {
    critical: {}
};

export const ParseMessage = function (message, groupId) {
    let messageStruct = /^@([a-zA-Z_]+)\s*(.*?)?$/m.exec(message);
    let command = 'text';
    let content = message;
    let dice = new DiceParser();

    if (messageStruct) {
        command = messageStruct[1];
        content = messageStruct[2];
    }

    switch(command) {
        case 'roll':
        case 'r':
        case 'silentroll':
        case 'sr':
        case 'totalroll':
        case 'tr':
        case 'silenttotalroll':
        case 'str':
        case 'hiddenroll':
        case 'hr':
            if (command === 'r') {
                command = 'roll';
            } else if (command === 'sr') {
                command = 'silentroll';
            } else if (command === 'tr') {
                command = 'totalroll';
            } else if (command === 'str') {
                command = 'silenttotalroll';
            } else if (command === 'hr') {
                command = 'hiddenroll';
            }

            dice.setCritical(criticalManager.critical[groupId]);
            content = DiceParser.processLastValue(content, groupId);
            content = dice.parse(content, groupId);
            criticalManager.critical[groupId] = dice.hasCritical;
            break;
        case 'multiroll':
        case 'mr':
            if (command === 'mr') {
                command = 'multiroll';
            }

            content = content.split('|').map(i => {
                dice.setCritical(criticalManager.critical[groupId]);
                
                let exp = DiceParser.processLastValue(i.trim(), groupId);
                let result = dice.parse(exp, groupId);

                criticalManager.critical[groupId] = dice.hasCritical;

                return result;
            });
            break;
        case 'rule': 
            content = content.split('|');
            content[1] = content[1] ? content[1].replace(/\\n/gim,'\n') : '';
            break;
        case 'addturn':
            content = content.split('|').map(i=> {
                return DiceParser.processLastValue(i.trim(), groupId);
            });
            content.push(groupId);
            break;
        default:
            let parts = [...matchRecursive(content, "[...]")];
            let expressionsTree = expandTreeExpressions(parts, {});

            content = resolveTreeExpressions(expressionsTree, content, false);
            content = DiceParser.processLastValue(content, groupId);
            content = evaluateMathExpressions(content);

            content = DiceParser.processCritical(content, criticalManager.critical[groupId]);
    }

    return {command, content};
}

export const GenerateMessageId = function () {
    let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    return Array(10).fill('').map(() => chars.charAt(Math.floor(Math.random() * 62))).join('');
}